jQuery(document).ready(function () {
    // Ensure __window is defined
    const __window = window.__window || jQuery(window);
    let __viewportW = __window.width();
    let __viewportH = __window.height();

    // smartresize when resize screen
    if (typeof __window.smartresize === 'function') {
        __window.smartresize(function () {
            __viewportW = __window.width();
            __viewportH = __window.height();
        });
    } else {
        __window.on('resize', function () {
            __viewportW = __window.width();
            __viewportH = __window.height();
        });
    }

    //menu animation
    if (__viewportW > __viewportSMP) {
        jQuery('.header_navi > li > ._split_text').each(function () {
            const $link = jQuery(this);

            // Prevent duplicate split
            if ($link.find('.menu-text').length) return;

            // Get only direct text nodes
            const text = $link
                .contents()
                .filter(function () {
                    return this.nodeType === 3;
                })
                .text()
                .trim();

            if (!text) return;

            const chars = Array.from(text);

            // Remove only direct text nodes
            $link
                .contents()
                .filter(function () {
                    return this.nodeType === 3;
                })
                .remove();

            const $wrapper = jQuery('<span class="_menutext">');

            jQuery.each(chars, function (i, ch) {
                const $char = jQuery('<span class="_char">').attr('data-char', ch);
                const $glyph = jQuery('<span class="_glyph">').text(ch);

                // Stagger animation
                const delay = i * 0.05 + 's';
                $glyph.css('transition-delay', delay);
                $char.css('--delay', delay);

                $char.append($glyph);
                $wrapper.append($char);
            });

            $link.append($wrapper);
        });

        // Hover li
        jQuery('.header_navi > li > ._split_text').hover(
            function () {
                jQuery(this).addClass('active');
            },
            function () {
                jQuery(this).removeClass('active');
            },
        );
    } else {
        //click menu
        const $trigger = jQuery('.header_menu_trigger .hamburger');
        const $body = jQuery('body');
        const $panel = jQuery('.header_panel');

        const closeMenu = () => {
            $trigger.removeClass('is-active');
            $body.removeClass('menu-open');
            $panel.removeClass('is-open');
        };

        $trigger.on('click', function (e) {
            e.preventDefault();
            const isOpen = $panel.hasClass('is-open');

            $trigger.toggleClass('is-active', !isOpen);
            $body.toggleClass('menu-open', !isOpen);
            $panel.toggleClass('is-open', !isOpen);
        });

        jQuery('.overlay').on('click', closeMenu);
        jQuery('.header_panel').on('click', 'a', closeMenu);
        jQuery(document).on('keydown', function (e) {
            if (e.key === 'Escape') closeMenu();
        });

        //click show sub menu
        jQuery('.header_navi >li.has_child').on('click', function (e) {
            if (!jQuery(e.target).closest('.header_navi_sub').length) {
                const $submenu = jQuery(this).find('.header_navi_sub');

                // jQuery('.header_navi_sub').not($submenu).slideUp();
                // jQuery('.has_child').not(this).removeClass('active');

                $submenu.stop(true, true).slideToggle(200);
                jQuery(this).toggleClass('active');
            }
        });
    }

    // __header small
    const __header_scroll_class = '_small';

    __window.on('scroll', function () {
        if (__window.scrollTop() > 100) {
            jQuery('#header').addClass(__header_scroll_class);
        } else {
            jQuery('#header').removeClass(__header_scroll_class);
        }
    });

    // scroll to top
    if (typeof jQuery.fn.toTopButton === 'function') {
        jQuery('body').toTopButton({
            imagePath: (typeof __path_media !== 'undefined' ? __path_media : '') + 'icons',
            arrowType: 'arrow-l',
            margin: 2,
            size: typeof __is_smp !== 'undefined' && __is_smp ? 2 : 4,
            backgroundColor: '#93001F',
            linkClasses: [' scroll_totop'],
            mobileHide: 0,
        });
    }

    // zoom img on SMP
    const smp_zoom = jQuery('.smp_zoom');
    if (smp_zoom.length > 0 && typeof __viewportSMP !== 'undefined' && __viewportW <= __viewportSMP) {
        smp_zoom.each(function () {
            const $img = jQuery(this);
            if (!$img.parent('a[data-fancybox]').length) {
                $img.wrap('<a data-fancybox href="' + $img.attr('src') + '"></a>');
            }
        });
    }

    // check element in view
    const in_view = jQuery('[class*="inview-"]');
    if (in_view.length > 0 && typeof in_view.on === 'function') {
        in_view.on('inview', function (event, isInView) {
            if (isInView) {
                jQuery(this).addClass('inview-active');
            }
        });
    }

    // fancybox
    if (typeof Fancybox !== 'undefined' && typeof Fancybox.bind === 'function') {
        Fancybox.bind('[data-fancybox]', {
            // Your custom options
        });
    }

    // main visual
    setTimeout(function () {
        const main_visual = jQuery('.main_visual');
        if (main_visual.length > 0) {
            const mainvisual_image =
                typeof __is_smp !== 'undefined' && __is_smp ? main_visual.data('imgsmp') : main_visual.data('imgpc');
            if (mainvisual_image) {
                main_visual.css('background-image', 'url(' + mainvisual_image + ')');
            }
        }
    }, 500);

    var bussiness_section__intro = jQuery('.business_section__intro');
    if (bussiness_section__intro.length > 0) {
        setTimeout(function () {
            bussiness_section__intro
                .find('._image')
                .css('min-height', bussiness_section__intro.find('._title').height());
        }, 500);
        // bussiness_section__intro.find('._image').height(bussiness_section__intro.find('._title').height());
    }

    var business_section__offer = jQuery('.business_section__offers_block');
    if (business_section__offer.length > 0) {
        business_section__offer.each(function () {
            var offer = jQuery(this);
            var p_tag = '._title ._text p';
            if (offer.find('._title ._text p.pc').length > 0 || offer.find('._title ._text p.smp').length > 0) {
                if (__viewportW > __viewportSMP) {
                    p_tag = '._title ._text p.pc';
                } else {
                    p_tag = '._title ._text p.smp';
                }
            }
            offer.attr('data-text-vertical-count', offer.find(p_tag).length);
        });
    }
});

jQuery(function ($) {
    jQuery(document).on('click', '.file-box', function (e) {
        if (!jQuery(e.target).is('input[type=file]')) {
            jQuery(this).find('input[type=file]').trigger('click');
        }
    });

    jQuery(document).on('click', '.file-btn', function (e) {
        e.stopPropagation();

        jQuery(this).closest('.file-box').find('input[type=file]').trigger('click');
    });

    jQuery(document).on('change', '.file-input', function () {
        let fileName = '選択されていません';

        if (this.files && this.files[0]) {
            fileName = this.files[0].name;
        }

        const box = jQuery(this).closest('.file-box');

        box.find('.file-name').text(fileName);

        if (jQuery(this).attr('name') === 'resume_file') {
            jQuery('input[name="resume_filename"]').val(fileName);
        }
    });
});
